import AppList, {AppListConfig} from "../../list";
import {
	Applicant,
	ApplicantRestControllerApiFactory,
	Candidate,
	CandidateRestControllerApiFactory,
	Recruitment,
	RecruitmentRestControllerApiFactory,
} from "arteco-api-client-ts";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../utils/api";
import React, {useEffect, useState} from "react";
import {COLOR_DISMISSED} from "../../colors";
import {useParams} from "react-router-dom";
import {dateToString} from "../../../utils/dates";
import {CustomNumberFormat} from "../../../utils/custom_number_format";
import {parsePathId} from "../../../form/form_utils";

const ApplicationsList = () => {
	const params = useParams();
	const recruitmentId = parsePathId(params, "recruitmentId", true);
	const candidateId = parsePathId(params, "candidateId", true);
	const apiManager = useApiManager();

	const applicantApi = apiManager.factory(ApplicantRestControllerApiFactory);
	const recruitmentApi = apiManager.factory(RecruitmentRestControllerApiFactory);
	const candidateApi = apiManager.factory(CandidateRestControllerApiFactory);

	const [recruitment, setRecruitment] = useState<Recruitment>();
	const [candidate, setCandidate] = useState<Candidate>();

	useEffect(() => {
		if (recruitmentId) {
			apiManager
			.executeRaw(recruitmentApi.getRecruitment(recruitmentId))
			.then((resp) => setRecruitment(resp.data));
		}
	}, [recruitmentId]);

	useEffect(() => {
		if (candidateId) {
			apiManager
			.executeRaw(candidateApi.getCandidate(candidateId))
			.then((resp) => setCandidate(resp.data));
		}
	}, [candidateId]);


	const listConfig: AppListConfig<Applicant> = {
		title:
			"Candidaturas " +
			(recruitment
				? "del Proceso " + recruitment?.title
				: candidate
					? "de " + candidate?.surnames + ", " + candidate?.name
					: ""),
		onClick: recruitment
			? "/app/admin/recruitment/recruitment/" + recruitmentId + "/application"
			: "/app/admin/recruitment/candidate/" + candidateId + "/application",
		headers: [
			{title: "Título"},
			{title: "Estado"},
			{title: "Tipo Candidato"},
			{title: "Solicitado", align: "right"},
			{title: "Pts.Candidatura"},
			{title: "Pts.Prueba"},
			{title: "Origen"},
			{title: "Notas", width: "20%"},
		],
		decorator: (bean: Applicant) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					{candidateId ? bean.recruitment?.title : ""}
					{!candidateId ? bean.candidate?.surnames + ", " + bean.candidate?.name : ""}
				</TableCell>
				<TableCell>
					{bean.state.name}
				</TableCell>
				<TableCell>
					{bean.candidate.type?.name || ""}
				</TableCell>
				<TableCell align={"right"} title={"Salario Solicitado"}>
					<CustomNumberFormat amount={bean.reqAnnualPayroll || bean.candidate.reqAnnualPayroll}/>
				</TableCell>
				<TableCell title={"Puntos Candidatura"}>
					{bean.rating || ""}
				</TableCell>
				<TableCell title={"Puntos Prueba Técnica"}>
					{bean.candidate.bestSolution?.points || ""}
				</TableCell>
				<TableCell>
					{bean.candidate.source?.label || ""}
				</TableCell>
				<TableCell style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
					{candidateId ? dateToString(bean.nextEvent) : ""}
					{!candidateId ? bean.comment : ""}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			return applicantApi.pageApplicant(
				currentPage,
				size,
				undefined,
				candidateId,
				recruitmentId,
				term,
				showDismissed
			);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};

export default ApplicationsList;
